module.exports = __webpack_public_path__ + "img/icon.a3405512.png";